import { render, staticRenderFns } from "./faq-question-reponse.vue?vue&type=template&id=c5a03bc0&scoped=true"
import script from "./faq-question-reponse.vue?vue&type=script&lang=js"
export * from "./faq-question-reponse.vue?vue&type=script&lang=js"
import style0 from "./faq-question-reponse.vue?vue&type=style&index=0&id=c5a03bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a03bc0",
  null
  
)

export default component.exports